// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.people_leaders__RplMy {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(15rem, 100%), 1fr));
  gap: var(--space-6);
  margin-bottom: clamp(3rem, 2rem + 4vw, 6rem);
}
@media (max-width: 640px) {
  .people_leaders__RplMy {
    display: flex;
    gap: var(--space-4);
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    margin-inline: calc(var(--gutter) * -1);
    padding-inline: var(--gutter);
    scrollbar-width: none;
  }
  .people_leader__UqwyN {
    flex: 0 0 72%;
    scroll-snap-align: start;
  }
}
.people_leader__UqwyN:hover .people_portrait__VCPtE img {
  transform: scale(1.03);
}
.people_name__Xi7Zf {
  margin: var(--space-4) 0 var(--space-1);
  font-size: var(--text-h3);
  font-weight: 500;
}
.people_role__5hGHu {
  margin: 0;
  color: var(--color-text-muted);
}

.people_railHead__3lBrt {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
  padding-top: var(--space-6);
  border-top: 1px solid var(--color-border);
}
.people_railTitle__rCL26 {
  margin: 0;
  font-size: var(--text-h3);
  font-weight: 500;
}
.people_rail__MRWWi {
  margin: 0;
  padding: 0 0 var(--space-3);
  list-style: none;
  display: flex;
  gap: var(--space-4);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: thin;
}
.people_card__uDKPl {
  flex: 0 0 min(13rem, 62vw);
  scroll-snap-align: start;
}

.people_cardName__XmM3D {
  margin: var(--space-4) 0 var(--space-1);
  font-size: 1.05rem;
  font-weight: 500;
  line-height: 1.25;
  /* two lines reserved so specialty and trial rows line up across cards */
  min-height: calc(1.05rem * 1.25 * 2);
}
.people_cardMeta__2yROp {
  margin: 0;
  font-size: var(--text-caption);
  color: var(--color-link);
}
.people_cardStat__6dRHE {
  margin: var(--space-1) 0 0;
  font-size: var(--text-caption);
  color: var(--color-text-muted);
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/PEOPLE/people.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sEAAsE;EACtE,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,uCAAuC;IACvC,6BAA6B;IAC7B,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,wBAAwB;EAC1B;AACF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wEAAwE;EACxE,oCAAoC;AACtC;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;AAChC","sourcesContent":[".leaders {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(15rem, 100%), 1fr));\n  gap: var(--space-6);\n  margin-bottom: clamp(3rem, 2rem + 4vw, 6rem);\n}\n@media (max-width: 640px) {\n  .leaders {\n    display: flex;\n    gap: var(--space-4);\n    overflow-x: auto;\n    scroll-snap-type: x mandatory;\n    margin-inline: calc(var(--gutter) * -1);\n    padding-inline: var(--gutter);\n    scrollbar-width: none;\n  }\n  .leader {\n    flex: 0 0 72%;\n    scroll-snap-align: start;\n  }\n}\n.leader:hover .portrait img {\n  transform: scale(1.03);\n}\n.name {\n  margin: var(--space-4) 0 var(--space-1);\n  font-size: var(--text-h3);\n  font-weight: 500;\n}\n.role {\n  margin: 0;\n  color: var(--color-text-muted);\n}\n\n.railHead {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: var(--space-3);\n  margin-bottom: var(--space-5);\n  padding-top: var(--space-6);\n  border-top: 1px solid var(--color-border);\n}\n.railTitle {\n  margin: 0;\n  font-size: var(--text-h3);\n  font-weight: 500;\n}\n.rail {\n  margin: 0;\n  padding: 0 0 var(--space-3);\n  list-style: none;\n  display: flex;\n  gap: var(--space-4);\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  scrollbar-width: thin;\n}\n.card {\n  flex: 0 0 min(13rem, 62vw);\n  scroll-snap-align: start;\n}\n\n.cardName {\n  margin: var(--space-4) 0 var(--space-1);\n  font-size: 1.05rem;\n  font-weight: 500;\n  line-height: 1.25;\n  /* two lines reserved so specialty and trial rows line up across cards */\n  min-height: calc(1.05rem * 1.25 * 2);\n}\n.cardMeta {\n  margin: 0;\n  font-size: var(--text-caption);\n  color: var(--color-link);\n}\n.cardStat {\n  margin: var(--space-1) 0 0;\n  font-size: var(--text-caption);\n  color: var(--color-text-muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leaders": `people_leaders__RplMy`,
	"leader": `people_leader__UqwyN`,
	"portrait": `people_portrait__VCPtE`,
	"name": `people_name__Xi7Zf`,
	"role": `people_role__5hGHu`,
	"railHead": `people_railHead__3lBrt`,
	"railTitle": `people_railTitle__rCL26`,
	"rail": `people_rail__MRWWi`,
	"card": `people_card__uDKPl`,
	"cardName": `people_cardName__XmM3D`,
	"cardMeta": `people_cardMeta__2yROp`,
	"cardStat": `people_cardStat__6dRHE`
};
export default ___CSS_LOADER_EXPORT___;
